import Flag from 'LuxKit/Flag'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import React, { MouseEvent, MouseEventHandler, useCallback } from 'react'

interface Props {
  region: App.RegionSummary
  onRegionClick: (region: App.RegionSummary, event: MouseEvent<HTMLButtonElement>) => void
}

function RegionListItem(props: Props) {
  const { region, onRegionClick } = props

  const handleClick = useCallback<MouseEventHandler<HTMLButtonElement>>((event) => {
    onRegionClick(region, event)
  }, [onRegionClick, region])

  return <ClickableListItem
    data-regioncode={region.code}
    aria-label={`Select ${region.name} region`}
    size="medium"
    startIcon={<Flag countryCode={region.code} />}
    title={region.name}
    onClick={handleClick}
  />
}

export default RegionListItem
